import { ApiResult, request, safeRequest } from '@synergy/api';
import { Canceler } from 'axios';

import { ContactDocument } from '../models/contact-detail-document';
import { DocumentPatchRequest } from './models/document-patch.request';

export class ContactDocumentsApi {
    constructor(protected baseUrl: string) {}

    public getDocuments(contactId: number): Promise<ApiResult<ContactDocument[]>> {
        return safeRequest(
            () => request.get<{ documents: ContactDocument[] }>(`${this.baseUrl}/contacts/${contactId}/documents`),
            response => response.data.documents
        );
    }

    public addDocument(
        contactId: number,
        file: File,
        cancelFunction?: (canceler: Canceler) => void,
        progressCallback?: (progress: ProgressEvent) => void
    ): Promise<ApiResult<ContactDocument>> {
        return safeRequest(
            () => {
                const data = new FormData();
                data.append('file', file, file.name);

                const config = {
                    headers: { 'content-type': 'multipart/form-data' },
                    onUploadProgress: progressCallback,
                    cancelToken: cancelFunction && new request.CancelToken(cancelFunction),
                };

                return request.post(`${this.baseUrl}/contacts/${contactId}/documents/upload`, data, config);
            },
            response => response.data
        );
    }

    public updateDocument(contactId: number, patch: DocumentPatchRequest): Promise<ApiResult<ContactDocument>> {
        return safeRequest(
            () =>
                request.patch(`${this.baseUrl}/contacts/${contactId}/documents/${patch.id}`, {
                    title: patch.title,
                }),
            response => response.data
        );
    }

    public deleteDocument(contactId: number, documentId: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/contacts/${contactId}/documents/${documentId}`),
            response => response.data
        );
    }
}
